import { useMemo } from 'react';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './styles.module.scss';
import TrailUgcTab from '../types/TrailUgcTab';

type UgcEmptyProps = {
  tab: TrailUgcTab;
};

const UgcEmpty = ({ tab }: UgcEmptyProps): JSX.Element => {
  const emptyMessage = useMemo(() => {
    switch (tab) {
      case 'photos':
        return <FormattedMessage defaultMessage="No one has added photos of this trail yet. Be the first!" />;
      case 'tracks':
        return <FormattedMessage defaultMessage="There are no activities for this trail yet. Create the first!" />;
      case 'completed':
        return <FormattedMessage defaultMessage="No one has completed this trail yet. Be the first!" />;
      default:
        return null;
    }
  }, [tab]);

  return <p className={styles.noMessage}>{emptyMessage}</p>;
};

export default UgcEmpty;
